<span
  *ngIf="displayStatus"
  class="tw-inline-flex tw-items-center"
  [matTooltip]="notAvailableTooltip | translate"
  [matTooltipDisabled]="displayStatus !== demurrageDetentionStatus.NotAvailable || !notAvailableTooltip"
>
  <span
    class="demurrage-detention-status demurrage-detention-status_{{ displayStatus | kebabCase }}"
    [style.width.px]="size"
    [style.height.px]="size"
  ></span>
  <span *ngIf="displayStatus === demurrageDetentionStatus.NotAvailable" class="tw-ml-1">{{ notAvailable }}</span>
</span>
